// Generated automatically by nearley, version 2.19.6
// http://github.com/Hardmath123/nearley
(function () {
function id(x) { return x[0]; }

const moo = require("moo");
const R = require("ramda");

const lexer = moo.compile({
  WS: /[ \t]+/,
  lineComment: /\/\/.*?$/,
  blockComment: { match: /\/\*(?:(?:.|\n)*?)\*\//, lineBreaks: true },
  string: /"(?:\\"|[^"\r\n])*?"/,
  char: /'(?:\\'|[^'\r\n])*?'/,
  lParen: "{",
  rParen: "}",
  NL: { match: /\n/, lineBreaks: true },
  otherCode: {
    match: /[^ \t\n\{\}]+/,
    type: moo.keywords({
      keyword: ["node", "nodespace", "meta"]
    })
  }
});

const value = R.path([0, "value"]);

const flattenNestedCodeBlock = R.pipe(
  R.pathOr([], [1]),
  R.join(''),
  code => `{${code}}`
);

const flattenCodeBlock = R.pipe(R.pathOr([], [0]), R.join(''));

const extractMetaContents = ([_kw, _ws, _paren, contents]) => contents;

const processNode = ([_kw, _ws, _paren, ...contents]) => {
  const [beforeMeta, meta, afterMeta] = contents.map(x => x == null ? '' : x);

  return {
    type: 'node',
    meta,
    contents: beforeMeta.concat(afterMeta),
  }
}

const processNodespace = ([_kw, _ws, _paren, contents]) => ({
    type: 'nodespace',
    contents: contents == null ? '' : contents,
  });

const markGlobalBlocks = R.pipe(
    R.reject(R.isNil),
    R.map(block => (typeof block === 'string') ? ({ type: 'global', contents: block }) : block),
  );

var grammar = {
    Lexer: lexer,
    ParserRules: [
    {"name": "main$ebnf$1", "symbols": ["codeBlock"], "postprocess": id},
    {"name": "main$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main$ebnf$2", "symbols": ["nodespace"], "postprocess": id},
    {"name": "main$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main$ebnf$3", "symbols": ["codeBlock"], "postprocess": id},
    {"name": "main$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main$ebnf$4", "symbols": ["codeBlock"], "postprocess": id},
    {"name": "main$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["main$ebnf$1", "main$ebnf$2", "main$ebnf$3", "node", "main$ebnf$4"], "postprocess": markGlobalBlocks},
    {"name": "whitespaceOrComments", "symbols": [(lexer.has("WS") ? {type: "WS"} : WS)], "postprocess": value},
    {"name": "whitespaceOrComments", "symbols": [(lexer.has("NL") ? {type: "NL"} : NL)], "postprocess": value},
    {"name": "whitespaceOrComments", "symbols": [(lexer.has("lineComment") ? {type: "lineComment"} : lineComment)], "postprocess": value},
    {"name": "whitespaceOrComments", "symbols": [(lexer.has("blockComment") ? {type: "blockComment"} : blockComment)], "postprocess": value},
    {"name": "codeBlock$ebnf$1$subexpression$1", "symbols": ["whitespaceOrComments"], "postprocess": id},
    {"name": "codeBlock$ebnf$1$subexpression$1", "symbols": [(lexer.has("string") ? {type: "string"} : string)], "postprocess": value},
    {"name": "codeBlock$ebnf$1$subexpression$1", "symbols": [(lexer.has("char") ? {type: "char"} : char)], "postprocess": value},
    {"name": "codeBlock$ebnf$1$subexpression$1", "symbols": [(lexer.has("otherCode") ? {type: "otherCode"} : otherCode)], "postprocess": value},
    {"name": "codeBlock$ebnf$1$subexpression$1$subexpression$1", "symbols": []},
    {"name": "codeBlock$ebnf$1$subexpression$1$subexpression$1", "symbols": ["codeBlock"]},
    {"name": "codeBlock$ebnf$1$subexpression$1", "symbols": [(lexer.has("lParen") ? {type: "lParen"} : lParen), "codeBlock$ebnf$1$subexpression$1$subexpression$1", (lexer.has("rParen") ? {type: "rParen"} : rParen)], "postprocess": flattenNestedCodeBlock},
    {"name": "codeBlock$ebnf$1", "symbols": ["codeBlock$ebnf$1$subexpression$1"]},
    {"name": "codeBlock$ebnf$1$subexpression$2", "symbols": ["whitespaceOrComments"], "postprocess": id},
    {"name": "codeBlock$ebnf$1$subexpression$2", "symbols": [(lexer.has("string") ? {type: "string"} : string)], "postprocess": value},
    {"name": "codeBlock$ebnf$1$subexpression$2", "symbols": [(lexer.has("char") ? {type: "char"} : char)], "postprocess": value},
    {"name": "codeBlock$ebnf$1$subexpression$2", "symbols": [(lexer.has("otherCode") ? {type: "otherCode"} : otherCode)], "postprocess": value},
    {"name": "codeBlock$ebnf$1$subexpression$2$subexpression$1", "symbols": []},
    {"name": "codeBlock$ebnf$1$subexpression$2$subexpression$1", "symbols": ["codeBlock"]},
    {"name": "codeBlock$ebnf$1$subexpression$2", "symbols": [(lexer.has("lParen") ? {type: "lParen"} : lParen), "codeBlock$ebnf$1$subexpression$2$subexpression$1", (lexer.has("rParen") ? {type: "rParen"} : rParen)], "postprocess": flattenNestedCodeBlock},
    {"name": "codeBlock$ebnf$1", "symbols": ["codeBlock$ebnf$1", "codeBlock$ebnf$1$subexpression$2"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "codeBlock", "symbols": ["codeBlock$ebnf$1"], "postprocess": flattenCodeBlock},
    {"name": "meta$ebnf$1", "symbols": []},
    {"name": "meta$ebnf$1", "symbols": ["meta$ebnf$1", "whitespaceOrComments"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "meta$ebnf$2", "symbols": ["codeBlock"], "postprocess": id},
    {"name": "meta$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "meta", "symbols": [{"literal":"meta"}, "meta$ebnf$1", {"literal":"{"}, "meta$ebnf$2", {"literal":"}"}], "postprocess": extractMetaContents},
    {"name": "node$ebnf$1", "symbols": []},
    {"name": "node$ebnf$1", "symbols": ["node$ebnf$1", "whitespaceOrComments"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "node$ebnf$2", "symbols": ["codeBlock"], "postprocess": id},
    {"name": "node$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "node$ebnf$3", "symbols": ["meta"], "postprocess": id},
    {"name": "node$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "node$ebnf$4", "symbols": ["codeBlock"], "postprocess": id},
    {"name": "node$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "node", "symbols": [{"literal":"node"}, "node$ebnf$1", {"literal":"{"}, "node$ebnf$2", "node$ebnf$3", "node$ebnf$4", {"literal":"}"}], "postprocess": processNode},
    {"name": "nodespace$ebnf$1", "symbols": []},
    {"name": "nodespace$ebnf$1", "symbols": ["nodespace$ebnf$1", "whitespaceOrComments"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "nodespace$ebnf$2", "symbols": ["codeBlock"], "postprocess": id},
    {"name": "nodespace$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "nodespace", "symbols": [{"literal":"nodespace"}, "nodespace$ebnf$1", {"literal":"{"}, "nodespace$ebnf$2", {"literal":"}"}], "postprocess": processNodespace}
]
  , ParserStart: "main"
}
if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.grammar = grammar;
}
})();



// WEBPACK FOOTER //
// ../src/implementationGrammar.ne.js